import { RelatedAdsCard } from '../../../../../components/PageWrappers/AdDetails/components/RelatedAds/components/RelatedAdsCard/RelatedAdsCard';

import type { RelatedAdsProps } from '../../../../../components/PageWrappers/AdDetails/components/RelatedAds/RelatedAds.typed';

import * as Styled from '../../../../../components/PageWrappers/AdDetails/components/RelatedAds/RelatedAds.styled';

import { useCampaignURLHandler } from '../../../../../components/PageWrappers/Hooks/Campaigns/UseCampaignURLHandler';
import convertToFriendlyPath from '../../../../../utils/FriendlyPath';
import { accessibleOnClick } from '../../../../../utils/Accessibility';

import { VIEW_TYPE } from '../../../../../components/ToolkitV2/CardV2/Card.typed';

const RelatedAds = (props: RelatedAdsProps) => {
  const { domain, relatedAds, viewType, testId } = props;

  const { handleCampaignAdRouterPush } = useCampaignURLHandler();

  return (
    <Styled.List viewType={viewType} data-testid={testId}>
      {relatedAds?.map((ad) => {
        const friendlyPath = convertToFriendlyPath(domain, ad.friendlyUrl!);

        return (
          <Styled.CardListItem
            key={ad.id}
            {...accessibleOnClick(
              () => handleCampaignAdRouterPush(friendlyPath),
              'link',
            )}
          >
            <RelatedAdsCard item={ad} isGrid={viewType === VIEW_TYPE.GRID} />
          </Styled.CardListItem>
        );
      })}
    </Styled.List>
  );
};

export { RelatedAds };
